import React from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system';
import { IconBank, IconCoinStack, IconMoneyBill } from 'design-system/icons';
import { IconBankCard } from 'design-system/icons/IconBankCard';
import { IconPiggy } from 'design-system/icons/IconPiggy';
import useColors from 'hooks/useColors';
import OnboardingSquircle from 'login/components/OnboardingSquircle';
import useIsTablet from 'hooks/useIsTablet';
const ICONS = [
    [IconMoneyBill, IconBank, IconBankCard],
    [IconCoinStack, IconPiggy],
];
const LoginsUpgradeBanner = () => {
    const colors = useColors();
    const isTablet = useIsTablet();
    return (<View style={[styles.container, isTablet && styles.largeContainer]}>
      {ICONS.map((row, index) => (<View style={styles.row} key={String(index)}>
          {row.map((Icon, index) => (<OnboardingSquircle key={index} small rotate color={colors.cards.onDark}>
              <Icon width={36} height={36} gradientKey="ultimate"/>
            </OnboardingSquircle>))}
        </View>))}
    </View>);
};
const styles = StyleSheet.create({
    container: {
        marginVertical: rem(32),
        alignItems: 'center',
    },
    largeContainer: {
        marginVertical: rem(48),
    },
    row: {
        flexDirection: 'row',
        gap: rem(30),
    },
});
export default LoginsUpgradeBanner;
